import * as React from 'react';
import cn from 'clsx';
import { IconChevronLeft16, ArticleParagraph1 } from '@cian/ui-kit';

import * as styles from './styles.css';

type TGoBackButtonProps = React.ComponentProps<'button'>;

export const GoBackButton: React.FC<React.PropsWithChildren<TGoBackButtonProps>> = props => {
  return (
    <button {...props} className={cn(styles['button'], props.className)} data-testid="prevQ">
      <span className={styles['icon']}>
        <IconChevronLeft16 color={'current_color'} display={'block'} />
      </span>
      <ArticleParagraph1 color={'current_color'}>{props.children}</ArticleParagraph1>
    </button>
  );
};

GoBackButton.displayName = 'GoBackButton';
